module.exports = __webpack_public_path__ + "img/checkbox-check.b2938f29.svg";